import React, { useState } from 'react'
import { userColumns, userRows } from '../../../datatablesource'
import Datatable from '../../datatable/Datatable'

import "./users.scss"
import { useTranslation } from 'react-i18next'
const Users = (props) => {


  const { t, i18n } = useTranslation();
    const [showPopup, setShowPopup] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

    const handleButtonClick = () => {
        setShowPopup(true);
    };
    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setShowPopup(false);
        props.onOptionSelected(option); // pass the selected option back to the parent component
    };

    // Custom cell component for the status column
    const StatusCell = ({ value }) => (
        <div onClick={() => setShowPopup(true)}
            style={{
                padding: "2px 5px",
                borderRadius: "5px",
                color: value === "active" ? "green" : "goldenrod",
                backgroundColor: value === "active" ? "rgba(0, 128, 0, 0.151)" : "rgba(189, 189, 3, 0.103)"

            }
            }
        >

            {value}
        </div>
    );
    const columns = [...userColumns(t)];
    const statusColumnIndex = columns.findIndex(c => c.field === 'status');
    columns[statusColumnIndex].renderCell = (params) =>

        <StatusCell value={params.value} />;


    return (
      <div>
        {showPopup && (
          <div className="popup-overlay" onClick={() => setShowPopup(false)}>
            <div className="popup" onClick={(event) => event.stopPropagation()}>
              <p>{t("User Status")}</p>
              <div className="radioDiv">
                <span>{t("Pending")} </span>{" "}
                <input type="radio" name="status" id="status" value="pending" />
                <span>{t("Verified")}</span>{" "}
                <input
                  type="radio"
                  name="status"
                  id="status"
                  value="verified"
                />
              </div>
            </div>
          </div>
        )}
        <Datatable
          data={userRows}
          secondaryColor="secondary"
          columnsName={columns}
          title={t("USERS")}
          statusPopUp={true}
        />
      </div>
    );
}

export default Users